module.exports = __webpack_public_path__ + "media/images/new_landing/articles/learn-4-efb524bc3032e03c341674b110347f79.jpg";